import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  Grid,
} from '@material-ui/core';
import FormField from '../../../_components/Authorization/FormField';

const useStyles = makeStyles((theme) => ({
  block: {
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: '1px solid #eee',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  blockTitle: {
    fontSize: '18px',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: theme.palette.black,
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  errorText: {
    fontSize: '12px',
    color: theme.palette.error.main,
    marginTop: '4px',
  },
}));

/**
 * OrderDataBlock - Блок "Дані для замовлення"
 * Поля: Ім'я, Прізвище, По батькові, Телефон, Email
 */
const OrderDataBlock = ({
  formState,
  errors,
  handleChange,
  handlePhoneChange,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const fieldInputProps = {
    InputProps: { className: 'form__field-input' },
    InputLabelProps: { className: 'form__field-label' },
  };

  return (
    <Box className={classes.block}>
      <Typography className={classes.blockTitle}>
        📋 {t('orderData') || 'Дані для замовлення'}
      </Typography>

      <Grid container spacing={2}>
        {/* Ім'я */}
        <Grid item xs={12} sm={6}>
          <FormField
            handleChange={handleChange}
            name="firstName"
            title={t('firstName') || 'Ім\'я'}
            type="text"
            formState={formState}
            hasErrorText={errors?.firstName ? errors.firstName[0] : ''}
          />
        </Grid>

        {/* Прізвище */}
        <Grid item xs={12} sm={6}>
          <FormField
            handleChange={handleChange}
            name="lastName"
            title={t('lastName') || 'Прізвище'}
            type="text"
            formState={formState}
            hasErrorText={errors?.lastName ? errors.lastName[0] : ''}
          />
        </Grid>

        {/* По батькові */}
        <Grid item xs={12}>
          <FormField
            handleChange={handleChange}
            name="fatherName"
            title={t('fatherName') || 'По батькові'}
            type="text"
            formState={formState}
            hasErrorText={errors?.fatherName ? errors.fatherName[0] : ''}
          />
        </Grid>

        {/* Телефон */}
        <Grid item xs={12} sm={6}>
          <FormField
            handleChange={handlePhoneChange}
            name="phone"
            title={t('phone') || 'Телефон'}
            type="tel"
            formState={formState}
            mask="+38 (999) 999-99-99"
            hasErrorText={errors?.phone ? errors.phone[0] : ''}
          />
        </Grid>

        {/* Email */}
        <Grid item xs={12} sm={6}>
          <FormField
            handleChange={handleChange}
            name="email"
            title={t('email') || 'Електронна пошта'}
            type="email"
            formState={formState}
            hasErrorText={errors?.email ? errors.email[0] : ''}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default OrderDataBlock;
